import { type LucideIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface IconLabelProps {
  icon: LucideIcon;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
}

export function IconLabel({
  icon: Icon,
  children,
  className,
  iconClassName,
}: IconLabelProps) {
  return (
    <span className={twMerge("inline-flex items-center gap-1", className)}>
      <Icon
        className={twMerge(
          "text-action-disabled-content size-3",
          iconClassName,
        )}
        strokeWidth={1.8}
      />
      <span className="text-content-muted text-[12px] font-medium">
        {children}
      </span>
    </span>
  );
}
